import { Component, input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-autocomplete-empty-message",
  templateUrl: "./autocomplete-empty-message.component.html",
  styleUrls: ["./autocomplete-empty-message.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AutocompleteEmptyMessageComponent {
  public readonly loading = input(false);
  public readonly text = input("No results found");
}
